import React from 'react';
import { Col, Layout, Row, Typography } from 'antd';
import GreetingsTop from '../../../../components/Admin/GreetingsTop/GreetingsTop';
import UsersTable from '../../../../components/Admin/Administration/Users/UsersTable/UsersTable';
import BackButton from '../../../../components/General/BackButton/BackButton';

export default function Users() {
  return (
    <Layout>
      <GreetingsTop />
      <HeaderTop />
      <div className="clients__container">
        <UsersTable />
      </div>
    </Layout>
  );
}

function HeaderTop() {
  const { Title } = Typography;

  return (
    <div className="clients__container">
      <Row xs={24} className="header-top">
        <Col xs={19} className="header-top__left">
          <Title
            level={3}
            style={{
              // position: 'absolute',
              top: 0,
              bottom: 0,
              height: '78%',
              margin: 'auto',
            }}
          >
            Usuarios
          </Title>
        </Col>
        <Col xs={5}>
          <Row
            style={{
              marginBottom: 30,
              justifyContent: 'right',
            }}
          >
            <BackButton routeName={'/administracion'}></BackButton>
          </Row>
        </Col>
      </Row>
    </div>
  );
}
